import React from 'react';

/**
 * רכיב המציג פריט יחיד ברשימת תכונות עם אייקון וטקסט
 * @param {string} text - הטקסט של התכונה להצגה
 */
const FeatureItem = ({ text }) => {
  return (
    <li className="flex items-center text-gray-600">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 sm:h-4 sm:w-4 md:h-5 md:w-5 text-green-500 ml-1 sm:ml-2" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
      </svg>
      {text}
    </li>
  );
};

export default FeatureItem;